import { images } from "@/assets";
import {
  Button,
  Card,
  CardContent,
  CardFooter,
  CardTitle,
} from "@/components/ui";
import { formatAmount } from "@/lib/utils";
import { ReceiptText, TriangleAlert } from "lucide-react";
import { OpenIncidentChart } from "./OpenIncidentChart";
import { FormSectionHeader, Loader } from "@/components";
import useCriticalActionSection from "./useCriticalActionSection";

const CriticalActionSection = () => {
  const {
    onInvoiceAwaitingClick,
    parkedStatus,
    isParkedStatus,
    isOpenIncidentLoading,
    openIncident,
    onViewIncident,
  } = useCriticalActionSection();
  return (
    <div className="bg-white rounded-lg p-[20px]">
      <FormSectionHeader className="text-[18px] font-[500]">
        Critical Actions & Alerts
      </FormSectionHeader>
      {isParkedStatus || isOpenIncidentLoading ? (
        <Loader />
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-[20px]">
          <Card className="bg-amber-100 border-none">
            <CardTitle className="flex flex-row items-center gap-4 px-5 text-[16px] md:text-[20px]">
              <div className="bg-white rounded-full h-[60px] w-[60px] p-2 flex items-center justify-center">
                <ReceiptText className="h-[30px] w-[30px]" />
              </div>
              Invoice Awaiting Approval
            </CardTitle>
            <CardContent className="bg-[rgba(255,255,255,0.7)] mx-5 p-4 rounded-lg">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div className="flex flex-row gap-3">
                  <div className="bg-yellow-500 rounded-full p-2 flex items-center justify-center text-white h-[40px] w-[40px]">
                    <ReceiptText />
                  </div>
                  <div className="flex flex-col text-[16px] mt-2 font-[500]">
                    Invoice To Review
                    <div className="text-yellow-500 text-[26px] flex flex-col">
                      <span>{parkedStatus?.data?.pendingApprovalCounts}</span>
                      <span>
                        {formatAmount(
                          parkedStatus?.data?.pendingApprovalAmount || 0
                        )}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="">
                  <img src={images.invoice_awaiting} />
                </div>
              </div>
            </CardContent>
            <CardFooter className="flex justify-end">
              <Button onClick={onInvoiceAwaitingClick}>View Details</Button>
            </CardFooter>
          </Card>
          <Card className="bg-blue-100 border-none">
            <CardTitle className="flex flex-row items-center gap-4 px-5 text-[16px] md:text-[20px]">
              <div className="bg-white rounded-full h-[60px] w-[60px] p-2 flex items-center justify-center">
                <TriangleAlert className="h-[30px] w-[30px]" />
              </div>
              Open Incident
            </CardTitle>
            <CardContent className="bg-[rgba(255,255,255,0.7)] mx-5 p-4 rounded-lg">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div className="flex flex-row gap-3">
                  <div className="bg-primary rounded-full p-2 flex items-center justify-center text-white h-[40px] w-[40px]">
                    <TriangleAlert />
                  </div>
                  <div className="flex flex-col text-[16px] mt-2 font-[500]">
                    Incidents
                    <div className="text-primary text-[26px] flex flex-col">
                      <span>
                        {openIncident?.data
                          ?.filter(
                            (item: any) =>
                              item.label?.toLowerCase() !== "longest open"
                          )
                          .reduce(
                            (sum: number, item: any) => sum + item.days,
                            0
                          ) || 0}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="lg:h-[150px] flex items-end">
                  <OpenIncidentChart data={openIncident?.data} />
                </div>
              </div>
            </CardContent>
            <CardFooter className="flex flex-col lg:flex-row gap-3 items-center justify-between">
              <span>
                Longest Open:{" "}
                {openIncident?.data?.find(
                  (data: any) => data.label?.toLowerCase() == "longest open"
                )?.days || "0"}{" "}
                Days
              </span>
              <Button onClick={onViewIncident}>View Details</Button>
            </CardFooter>
          </Card>
        </div>
      )}
    </div>
  );
};

export default CriticalActionSection;
